import React, { useEffect, useState } from "react";
import {
  Table,
  Badge,
  Dropdown,
  Button,
  Form,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import {
  changeStatusApi,
  deleteTeamApi,
  deleteUserApi,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import Swal from "sweetalert2";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import { FaPencil } from "react-icons/fa6";
import { BASE_URL } from "../../../services/path";

const TableList = ({
  userData,
  setUser,
  fetchedGetUsers,
  pageLoader,
  handleShowModal,
  currentPage,
  rowsPerPage
}) => {
  const notification = useToastContext();

  // ALL STATE
  const [loader, setLoader] = useState(false);

  const handelDelete = async (id) => {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Delete",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { id };
          deleteTeamApi(requestPayload, notification, (loading, error) => {
            setLoader(loading);

            if (!error) {
              fetchedGetUsers();
              setLoader(loading);
            }
          });
        } catch (error) {
          console.error("error:", error);
          setLoader(false);
        }
      }
    });
  };

  const positionMapping = {
    ChiefSecretary: "अध्यक्ष",
    GeneralTreasury: "महासचिव",
    Chief: "कोषाध्यक्ष",
    "Co-Treasurer": "सह कोषाध्यक्ष",
    VicePresident: "उपाध्यक्ष",
    Volunteer: "कार्यकारणी सदस्य",
    Guard: "सरक्षक",
    JointSecretary: "संयुक्त सचिव",
    OrganizationSecretary: "संगठन सचिव",
    WomenCellInCharge: "महिला प्रकोष्ठ प्रभारी",
    YouthCellInCharge: "युवा प्रकोष्ठ प्रभारी",
    CulturalInCharge: "सांस्कृतिक प्रभारी",
    MediaInCharge: "मीडिया प्रभारी",
  };

  const renderPosition = (position) => {
    return positionMapping[position] || position; // Fallback to original value if no match is found
  };

  return (
    <div className="card overflow-hidden all-tables">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Position</th>
                <th>Image</th>
                <th>Created At</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            {!pageLoader && userData?.length !== 0 && (
              <tbody>
                {userData &&
                  userData?.length > 0 &&
                  userData?.map((item, index) => {
                    return (
                      <tr>
                        <td>
                          <strong className="text-black">{(currentPage - 1) * rowsPerPage + index + 1}</strong>
                        </td>
                        <td>{item?.name}</td>
                        <td>{renderPosition(item?.position)}</td>
                        <td>
                          {/* <img src={item?.volentierPic} alt="NO_IMAGE" /> */}
                          <img
                            src={
                              BASE_URL + "/uploads/" + item?.volentierPic || ""
                            }
                            style={{
                              height: "30px",
                              width: "30px",
                              borderRadius: "8px",
                            }}
                            alt="NO_IMAGE"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                            }}
                          />
                        </td>

                        <td>{formatDate(item?.createdAt)}</td>

                        <td className="text-center">
                          <div className="d-flex align-items-center justify-content-center">
                            <Link
                              to=""
                              className="text-black fs-6 px-1"
                              onClick={() => handleShowModal("edit", item)}
                            >
                              <FaPencil />
                            </Link>
                            <Link
                              to=""
                              className="text-danger fs-5 px-1"
                              onClick={() => handelDelete(item?._id)}
                            >
                              <MdDeleteForever />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}

            {/* {userData?.length < 0 && (
              <tbody>
                <tr className="text-center" colspan={7}>
                  <td colspan={7}>No Record Found</td>
                </tr>
              </tbody>
            )} */}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default TableList;
